import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="专题分类"
          title="按套路类型查找档案"
          desc="不同类型的骗局有各自的破绽。先从你最可能遇到的那一类看起，会比漫无目的地浏览更有效。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat) => {
            const count = articles.filter((a) => a.category === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/archives?category=${cat.slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-6"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${cat.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-5 flex items-center justify-between text-xs text-foreground-500">
                  <span>{count} 篇档案</span>
                  <i className="ri-arrow-right-line text-primary-600 transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}